// @flow

import * as React from 'react'
import styled from 'styled-components'
import { RobotoBlack } from './Typography/Fonts'
import { Colors } from './Colors'

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  right: 0;
  left: 0;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${RobotoBlack.fontFamily};
  font-size: 12px;
  font-weight: ${RobotoBlack.weight};
  line-height: 15px;
  color: ${process.env.REACT_APP_LIGHT_UI === 'true'
    ? Colors.black30
    : Colors.white30};
`

export default (): React.Node => {
  return <Wrapper>Custhome®</Wrapper>
}
